import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface CalendarGridProps {
  className?: string;
  children?: ReactNode;
  dataTestId: string;
}

export const CalendarGrid: FC<CalendarGridProps> = ({
  className,
  children,
  dataTestId,
}) => {
  const mainClassName = clsx(
    'vtmn-grid vtmn-grid-cols-7 vtmn-gap-y-1 vtmn-gap-x-1',
    className,
  );
  return (
    <div data-testid={dataTestId} className={mainClassName}>
      {children}
    </div>
  );
};
